import { ChangeDetectionStrategy, Component, DOCUMENT, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SearchGroupModel } from '../../models/search-group.model';
import { SearchItemModel } from '../../models/search-item.model';
import { MetaResource } from '../../services/resources/meta.resource';

@Component({
    selector: 'sl-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchComponent implements OnInit {
    groups: SearchGroupModel[] = [];
    isSearching = true;
    displayedColumns: string[] = ['label'];

    private readonly document = inject(DOCUMENT);
    private readonly router = inject(Router);
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly metaResource = inject(MetaResource);

    ngOnInit(): void {
        this.activatedRoute.paramMap.subscribe(params => {
            this.groups = [];
            const searchTerm = params.get('searchTerm');

            if (!!searchTerm) {
                this.isSearching = true;
                this.metaResource.search(searchTerm).subscribe(resp => this.loadSearchResults(resp.value));
            } else {
                this.isSearching = false;
            }
        });
    }

    goToView(item: SearchItemModel): void {
        if (item.groupType !== 'tenants') {
            const path = this.getBaseRoute(item.groupType);
            this.router.navigate([path, item.id]);
        } else {
            this.document.location.href = item.id;
        }
    }

    private getBaseRoute(groupType: string): string {
        return groupType + 's';
    }

    private loadSearchResults(result: SearchItemModel[]): void {
        const names = result.map(r => r.groupType);
        const distinctGroupNames = [...new Set(names)];

        distinctGroupNames.forEach(n => this.groups.push(new SearchGroupModel({ groupType: n })));

        result.forEach(item => {
            const group = this.groups.find(g => g.groupType === item.groupType)!;
            group.groupName = item.groupName;
            group.items.push(item);
        });

        this.isSearching = false;
    }
}
